<template>
  <div class="dropdown w-100" ref="referencesDropdown">
    <label class="text-form mb-2 mt-4 fw-400 color--dark-900">{{
      config.label
    }}</label>
    <button
      class="btn dropdown-toggle form-control text-start dropdown-custom"
      type="button"
      @click="openDropButton"
      :class="!error ? '' : 'invalid'"
      ref="buttonAction"
    >
      <i
        class="icon fa-regular fa-check-to-slot"
        :class="{ invalid: error, 'color--primary': !error }"
      />
      <span class="text fw-300 ps-1">{{ selectedItem.label }}</span>
    </button>
    <ul ref="dropdownMenu" class="dropdown-menu custom-dropdown-menu w-100">
      <li v-for="(item, i) in list" :key="i">
        <a
          :class="{ active: selectedItem.label == item.label }"
          class="dropdown-item"
          @click="selectItem(item)"
        >
          <span class="text">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { Dropdown } from "bootstrap";
export default {
  emits: ["get-item"],
  name: "custom-dropdown",
  props: {
    modelValue: String,
    config: {
      type: Object,
      default: () => ({
        label: "Selecione uma opção*",
      }),
    },
    list: {
      default: [
        { label: "Item 1" },
        { label: "Item 2" },
        { label: "Item 3" },
        { label: "Item 4" },
      ],
    },
    selectedItem: {},
    error: {},
    dropDownId: {
      type: Number,
      default: () => new Date().getTime(),
    },
  },
  data() {
    return {
      dropdownMenu: "",
      openMenu: false,
    };
  },
  mounted() {
    this.dropdownMenu = new Dropdown(this.$refs.dropdownMenu, {
      offset: [0, 0],
      reference: this.$refs.referencesDropdown,
    });
  },
  methods: {
    addClick(event) {
      var menu = this.$refs.dropdownMenu;
      var button = this.$refs.buttonAction;
      var click = menu.contains(event.target);
      var clickButton = button.contains(event.target);
      if (!click && !clickButton) {
        this.closeDropDownMenu();
      }
    },
    closeDropDownMenu() {
      this.openMenu = false;
      document.removeEventListener("click", this.addClick);
      this.dropdownMenu.hide();
    },
    openDropDownMenu() {
      this.openMenu = true;
      document.addEventListener("click", this.addClick);
      this.dropdownMenu.show();
    },
    openDropButton() {
      if (this.openMenu) {
        this.closeDropDownMenu();
      } else {
        this.openDropDownMenu();
      }
    },
    closeDropDown() {
      var dropdownRole = Dropdown.getInstance(this.$refs[this.dropDownId]);
      dropdownRole.hide();
    },
    selectItem(item) {
      this.closeDropDownMenu();
      this.getItem(item);
    },
  },
  setup(props, context) {
    const getItem = (item) => {
      context.emit("get-item", item);
    };

    return { getItem };
  },
};
</script>

<style scoped>
.dropdown-menu .active {
  background-color: #e6e7ec;
}
.custom-dropdown-menu {
  width: 100%;
  max-width: 100%;
  margin-top: 10px !important;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgb(0 0 0 / 16%);
  border: none;
  transition: all 0.2s ease;
  /* transform: translate(0px, 65px); */
}

.custom-dropdown-menu li {
  padding: 6px, 12px, 6px, 12px;
  border: none;
  font-size: 16px !important;
  margin-bottom: 8px;
}
.custom-dropdown-menu .active {
  font-weight: 600;
}
.custom-dropdown-menu li:hover {
  font-weight: 600;
}
.custom-dropdown-menu li a {
  padding: 5px 15px 5px 15px;
}

.custom-dropdown .close .icon {
  transition: 0.4s ease;
  transform: rotate(0);
}
</style>
